import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
const AccordionCommonComponent = ({
  modalOpen,
  title,
  enabledAddButton,
  t,
  parentClass,
  childClass,
  children,
  uuid,
}) => {
  return (
    <AccordionItem uuid={uuid}>
      <AccordionItemHeading>
        <AccordionItemButton>
          <div className="row no-gutters align-items-center">
            <div className="col-6">
              <h2 className="title">{title}</h2>
            </div>

            <div className="col-6">
              <span className="arrow_ico">
                <img
                  src={require("assets/images/ico-forward.svg").default}
                  alt="img"
                />
              </span>
              {enabledAddButton && (
                <button
                  className="button button-round button-shadow float-md-right"
                  onClick={modalOpen}
                >
                  {t("accountOwner.addNewRole")}
                </button>
              )}
            </div>
          </div>
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <div className={parentClass}>
          {childClass ? <div className={childClass}>{children}</div> : children}
        </div>
      </AccordionItemPanel>
    </AccordionItem>
  );
};
export default AccordionCommonComponent;